<template>
  <div class="navigation clearfix">
    <div class="fl logo-img">
      <img src="@/assets/img/logo-bg.png">
    </div>
    <div class="menu fr clearfix ">
      <div v-for="(item, index) in items" :key="index" class="menu-list">

        <div v-if="item.children" class="aboutUs" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
          <span @click="menusTo(item.href)" :class="{menuActive:activeMenuItem === item.href}">{{item.menuName }}</span>
          <i class="menu-icon el-icon-arrow-down" v-if="arrowIsShow==true"></i>
          <i class="menu-icon el-icon-arrow-up" v-else></i>
          <ul class="aboutUs-list">
            <li v-for="(childItem, idx) in item.children" :key="idx" @click="navigateTo(childItem.href,childItem.anchor)">
              <span>{{childItem.menuName }}</span>
            </li>
          </ul>
        </div>

        <div v-else>
          <span @click="menusTo(item.href)" :class="{menuActive:activeMenuItem === item.href}">{{item.menuName }}</span>
        </div>
      </div>
    </div> 
  </div>
</template>

<script>
import bus from "@/utils/bus";
import menu from '@/assets/json/menu.json'

export default {
  data() {
    return {
      items: [],
      menu: [],
      activeMenuItem:null,
      arrowIsShow:true
    };
  },
  created() {
  },
  mounted() {
    this.getMenu();
  },
  components: {
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.activeMenuItem = this.$route.path
      },
      deep: true, // 深层监听
      immediate: true, // 初始化监听
    },
  },
  activated() {
  },
  methods: {
    getMenu() {
      this.items = menu;
    },
    // 点击菜单跳转页面
    menusTo(path){
      this.activeMenuItem = path;
      if(path == '/authentication' || path == '/mcn' || path == '/shop'){
        window.open('/#'+path,"_blank")
      }else{
        if(this.$route.path===path){
          this.$router.go(0)
        }else{
          this.$router.push({path,query:null})
       }
     }
  },
    //点击二级菜单跳转页面
    navigateTo(path,anchor){
      this.activeMenuItem = path;
      if(this.$route.query.anchor===anchor){
        this.$router.go(0)
      }else{
        this.$router.push({path,query:{anchor}})
      }
    },
    onMouseEnter(){
      this.arrowIsShow = false;
    },
    onMouseLeave(){
      this.arrowIsShow = true;
    }
  }
};
</script>  

<style scoped>
.navigation{
  padding: 0 110px;
  width: 100%;
  height: 76px;
  line-height: 76px;
  background: #ffffff;    
  box-sizing: border-box;
}
.logo-img{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.menu-list{
  float: left;
  margin-right: 50px;
}
.menu-list:last-child{
  margin-right: 0;
}
.menu-list span{
  font-size: 16px;
  color: #323233;
  cursor: pointer;
}
.menu-list span:active,.menu-list span:hover{
  color: #4670e8;
  font-weight: 600;
}
.menu-icon{
  padding-left: 5px;
  font-size: 12px;
}
.aboutUs{
  position: relative;
}
.aboutUs-list{
  display: none;
  position: absolute;
  left: -19px;
  top: 76px;
  z-index: 9999;
}
.aboutUs-list li{
  padding: 7px 18px;
  min-width: 100px;
  box-sizing: border-box;
  line-height: 32px;
  background: #ffffff;
}
.aboutUs-list li:last-child{
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}
.aboutUs:hover .aboutUs-list{
  display: block;
}
.menuActive{
  color: #4670e8!important;
}
</style>
